import Home from "@/views/en/Home";
import Radio from "@/views/en/Radio";
import Links from "@/views/en/Links";
import Contact from "@/views/en/ContactInfo";
import AboutUs from "@/views/en/AboutUs";
import notFound from "@/views/en/notFound";

import Radio_LTB from "@/views/en/Radio_LTB";
import Radio_LTB_Q from "@/views/en/Radio_LTB_Q";
import videoNamihira from "@/views/en/videos/namihira_story";
import videoChurch from "@/views/en/videos/namihira_church";
import CDPlayer from "@/views/en/CDPlayer";
import Docs from "@/views/en/Docs.vue";

export default [
   {
      path: '/',
      name: 'home',
      component: Home
   },


   {
      path: '/radio',
      name: 'radio',
      component: Radio
   },
   {
      path: '/music',
      name: 'music',
      component: CDPlayer
   },

   {
      path: '/radio/living-the-bible',
      name: 'livingTheBible',
      component: Radio_LTB
   },

   {
      path: '/radio/living-the-bible-q',
      name: 'livingTheBible_Q',
      component: Radio_LTB_Q
   },

   // {
   //    path: '/video',
   //    name: 'videos',
   //    component: Video
   // },

   {
      path: '/video/namihira-story',
      name: 'videoNamihira',
      component: videoNamihira
   },

   {
      path: '/video/namihira-church',
      name: 'videoNamihira',
      component: videoChurch
   },

   {
      path: '/docs',
      name: 'docs',
      component: Docs
   },

   {
      path: '/links',
      name: 'links',
      component: Links
   },

   {
      path: '/contact',
      name: 'contact',
      component: Contact
   },

   {
      path: '/aboutus',
      name: 'aboutUs',
      component: AboutUs
   },


   {
      path: '/contact',
      name: 'contact',
      component: Contact
   },

   // {
   //    path: '/thankyou',
   //    name: 'thankyou',
   //    component: Thanks
   // },
   {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
         return import(/* webpackChunkName: "about" */ '../views/en/About.vue')
      }
   },

   {
      path: '*',
      name: 'notFound',
      component: notFound
   },

];



